// src/AnimatedButton.js

import React, { memo } from 'react';
import { motion } from 'framer-motion';
import './AnimatedButton.css';

const AnimatedButton = memo(({ onClick, label = "Start Generating", icon = "✦" }) => {
  return (
    <motion.button
      className="animated-btn"
      onClick={onClick}
      aria-label={label}
      type="button"
      whileTap={{ scale: 0.95 }}
      transition={{ type: "spring", stiffness: 400, damping: 25 }}
    >
      <div className="animated-btn__wrap">
        <p className="animated-btn__text">
          {label}
          <span className="animated-btn__icon-default">{icon}</span>
          <span className="animated-btn__icon-hover">✦</span>
        </p>
      </div>
    </motion.button>
  );
});

AnimatedButton.displayName = 'AnimatedButton';

export default AnimatedButton;